<template>
  <v-autocomplete
    ref="autocomplete"
    :value="value"
    :items="items"
    :multiple="multiple"
    :search-input.sync="search"
    :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
    clearable
    cache-items
    v-bind="$attrs"
    v-on="listeners"
  >
    <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'lodash';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import autocomplete from './mixins/autocomplete';

const DEBOUNCE_DELAY = 500;

export default {
  name: 'BaseAutocompleteSearchRequestFilter',

  mixins: [autocomplete, i18nRefreshData],

  props: {
    defaultSearch: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      searchCache: new Set()
    };
  },

  watch: {
    search: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal && newVal.trim() !== this.value) {
          this.getDataDebounced(newVal);
        }
      }
    },
    defaultSearch: {
      deep: true,
      immediate: true,
      handler() {
        this.setSearch(this.defaultSearch);
      }
    }
  },

  methods: {
    setSearch(defaultSearch) {
      if (defaultSearch) {
        this.search = defaultSearch;
        this.getData(this.search);
      }
    },
    async refreshData() {
      if (this.searchCache.size === 0) {
        return;
      }

      const items = [];

      for (const search of this.searchCache) {
        const result = await this.getData(search);
        items.concat(result);
      }

      this.$refs.autocomplete.cachedItems = [];
      this.items = items;
    },

    getDataDebounced: debounce(function debouncedGetData(search) {
      if (search && !this.searchCache.has(search)) {
        this.getData(search).then(items => {
          this.items = items;
          this.searchCache.add(search);
        });
      }
    }, DEBOUNCE_DELAY),

    /**
     * Get data items
     *
     * @param search
     * @returns {Promise<never>}
     */
    // eslint-disable-next-line no-unused-vars
    getData(search) {
      return Promise.reject(new Error('"getData" function is not implemented'));
    }
  }
};
</script>
